import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=69638055&scoped=true&v-for=(contact%2C%20index)%20in%20contact&%3Akey=index&"
import script from "./Contact.js?vue&type=script&lang=js&"
export * from "./Contact.js?vue&type=script&lang=js&"
import style0 from "./Contact.scss?vue&type=style&index=0&id=69638055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69638055",
  null
  
)

export default component.exports